import React, { useCallback, useMemo } from 'react';

import { FiX } from 'react-icons/fi';
import { unshareBoard } from '../../../services/api/api';
import { useCurrentBoard, useCurrentUser } from '../../../services/state';
import { LoadingSpinner } from '../../common/loading-spinner/LoadingSpinner';
import { isFeatureEnabled } from '../../../services/feature-flags';

import '../../../style/Common.css';

const UsersWithAccess = ({ permissions, setPermissions, loading }) => {
  const { email: userEmail } = useCurrentUser();
  const { id: boardId } = useCurrentBoard();

  const usersWithAccess = useMemo(
    () =>
      permissions.permissions === undefined
        ? []
        : Object.keys(permissions.permissions)
            .flatMap(role => permissions.permissions[role].map(user => ({ ...user, role })))
            .filter(user => user.email !== userEmail),
    [userEmail, permissions]
  );

  const pendingInvitations = useMemo(
    () =>
      permissions.invitations === undefined
        ? []
        : Object.keys(permissions.invitations).flatMap(role =>
            permissions.invitations[role].map(email => ({ email, role }))
          ),
    [permissions]
  );

  const removeUser = useCallback(
    async user => {
      const userId = user.id ? user.id : user.email;
      const newPermissions = await unshareBoard({
        boardId,
        role: user.role,
        userIds: [userId]
      });
      setPermissions(newPermissions);
    },
    [boardId, setPermissions]
  );

  return (
    <div className="AddedEmailsSectionWrapper">
      <h3 className="m-b-1">People with access</h3>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <UserList users={usersWithAccess} removeUser={removeUser} pending={false} />
      )}
      {isFeatureEnabled('SHOW_PENDING_INVITATIONS') && (
        <>
          <h3 className="m-b-1">Pending invitations</h3>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <UserList users={pendingInvitations} removeUser={removeUser} pending={true} />
          )}
        </>
      )}
    </div>
  );
};

const UserList = ({ removeUser, users, pending }) => {
  return users.length === 0 ? (
    <div className="m-b-1">
      {pending
        ? 'There are no pending invitations'
        : 'This board is not shared with registered users'}
    </div>
  ) : (
    <div className="AddedEmailsSection">
      {users.map(user => (
        <div key={`${user.role}_${pending ? user.email : user.id}`} className="addedEmailBlock">
          <div className="added-user-email">{user.email}</div>
          <div className="role">{user.role}</div>
          <div className="remove-icon" onClick={() => removeUser(user)}>
            <FiX size={'0.8rem'} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default UsersWithAccess;
